module.exports = __webpack_public_path__ + "fonts/onprem@2x.3772b6499d560b33f2fc568c8b7f8712.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/onprem@2x.png
// module id = 745
// module chunks = 9